document.addEventListener('DOMContentLoaded', () => {
  // define elements
  const root = document.querySelector(':root');
  const body = document.body;
  const orb = document.getElementById('orb');

  // define vars
  const pctRingIlluminated = 0.95;
  const lightsPerRing = 12;
  const ringsPerOrb = 12;
  const lightBorderWidthRange = [2, 10];
  const lightBlurRange = [1, 7];

  // define flags
  const blurWithFilter = false;  // alternatively, use box-shadow

  // store dimensions
  let windowW = window.innerWidth;
  let windowH = window.innerHeight;

  // init fn
  const init = () => {
    recalculateDimensions();
    addRingsToOrb();
  };

  // offset-path#path() is experimental, doesn't like css vars
  // define a fn that converts var(--size) to px coords
  const buildOffsetPath = () => {
    const d = orb.offsetHeight;
    return `path("M 0,${d/2} a ${d/2},${d/2} 0 1,0 ${d},0 a ${d/2},${d/2} 0 1,0 -${d},0")`
  };

  const setOffsetPath = () => {
    root.style.setProperty('--offset-path', buildOffsetPath());
  };

  // build lights in a ring
  const addLightsToRing = (ring, styles) => {
    const distancesAlongRing = Array.apply(null, { length: lightsPerRing }).map((d, i) => Math.random() * pctRingIlluminated * 100);
    distancesAlongRing.forEach(distanceAlongRing => {
      // create light
      const light = document.createElement('span');
      light.classList.add('light');

      // add random features
      light.style.setProperty('offset-distance', `${distanceAlongRing}%`);
      const intensity = Math.random();
      const rBase = Math.round(intensity * (lightBorderWidthRange[1] - lightBorderWidthRange[0])) + lightBorderWidthRange[0];
      const rSpread = Math.round(intensity * (lightBlurRange[1] - lightBlurRange[0])) + lightBlurRange[0];
      if (blurWithFilter) {
        light.style.setProperty('border-width', `${rBase}px`);
        light.style.setProperty('filter', `blur(${rSpread}px)`);
      } else {
        light.style.setProperty('border-width', '0.5px');
        light.style.setProperty('box-shadow', `0 0 ${rBase}px ${rSpread}px ${styles.color}`);
      }

      // counteract rotation of orb & ring (in reverse order)
      light.style.setProperty('transform', `translate(-50%,-50%) rotateX(${styles.rotation}deg) rotate3d(var(--rotate-x), var(--rotate-y), 0, -90deg)`);
      light.style.setProperty('border-color', styles.color);

      // append
      ring.appendChild(light);
    });
  };

  // build rings
  const addRingsToOrb = () => {
    const ringTilts = Array.apply(null, { length: ringsPerOrb }).map((d, i) => i * 180 / ringsPerOrb);
    const ringColors = ['white', 'lightgoldenrodyellow', 'lightblue', 'lightpink', 'lightgreen', 'lightcoral'];
    ringTilts.forEach((ringTilt, i) => {
      // create ring
      const ring = document.createElement('div');
      ring.classList.add('ring');

      // increment rotation for surface coverage
      ring.style.setProperty('transform', `rotateX(-${ringTilt}deg)`);

      // add lights
      addLightsToRing(ring, {
        rotation: ringTilt,
        color: ringColors[(i % ringColors.length)]
      });

      // append
      orb.appendChild(ring);
    });
  };

  // update orb rotation based on cursor position
  const setOrbRotation = e => {
    const xToEdge = (e.x - (windowW / 2)) / (windowW / 2);
    const yToEdge = (e.y - (windowH / 2)) / (windowH / 2);
    const furtherToEdge = Math.max(Math.abs(xToEdge), Math.abs(yToEdge));
    root.style.setProperty('--rotate-x', (yToEdge / furtherToEdge));
    root.style.setProperty('--rotate-y', (xToEdge / -furtherToEdge));
  };

  // recalculate various dimensions when window size changes
  const recalculateDimensions = () => {
    window.addEventListener('resize', e => {
      // set window dimensions
      windowW = window.innerWidth;
      windowH = window.innerHeight;

      // offset-path for circular tracks
      setOffsetPath();
    });

    // initialize
    window.dispatchEvent(new Event('resize'));
  };

  // bind motion handlers
  window.addEventListener('mousemove', setOrbRotation);
  window.addEventListener('touchmove', setOrbRotation);

  // initialize
  init();
});
